import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Assessments from "./pages/Assessments";
import Schools from "./pages/Schools";
import Partner from "./pages/Partner";
import AboutUs from "./pages/AboutUs";
import Research from "./pages/Research";
import Contact from "./pages/Contact";
import Book from "./pages/Book";
import Discover from "./pages/Discover";
import MasterAdmin from "./pages/admin/MasterAdmin";
import { Blog, BlogPost } from "./pages/Blog";
import { Terms, RefundPolicy, PrivacyPolicy } from "./pages/Legal";
import ShareBar from "./components/ShareBar";
import MobileBottomNav, { MobileNavProvider } from "./components/MobileBottomNav";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/discover") || pathname.startsWith("/masteradmin");
  return (
    <>
      {!bare && <Navbar />}
      {!bare && <ShareBar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/assessments" element={<Assessments />} />
          <Route path="/schools" element={<Schools />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/research" element={<Research />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<Book />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/masteradmin" element={<MasterAdmin />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <MobileBottomNav />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MobileNavProvider>
          <ScrollToTop />
          <Shell />
          <Toaster />
        </MobileNavProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
